import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  fileTypeCell: {
    paddingLeft: theme.spacing(2),
  },
  lastModifiedHeadCell: {
    paddingRight: theme.spacing(2),
  },
  lastModifiedBodyCell: {
    textAlign: 'right',
  },
  actionCell: {
    textAlign: 'right',
  },
  tableWrapper: {
    '& tr:nth-last-child(2):not(.expanded) td:first-child': {
      borderBottomLeftRadius: 0,
    },
    '& tr:nth-last-child(2):not(.expanded) td:last-child': {
      borderBottomRightRadius: 0,
    },
  },
}));

export default useStyles;
